let imageViewerLaunched = false;
let imageViewerWindow = null;

let flagSyncChannel;
let selectionSyncChannel;
let loadedResultsSyncChannel;

function launchImageViewer(initialResultIds) {

    if (imageViewerLaunched) {
        return;
    }

    const orderId = getOrderId();
    const searchId = getSelectedSearchId();
    const randomKey = Math.random().toString(36).slice(-4);
    const syncKey = `${orderId}-${searchId}-${randomKey}`;
    console.log(`Launching image viewer with sync key: ${syncKey}`);

    flagSyncChannel = new BroadcastChannel('flag-updates-' + syncKey);
    selectionSyncChannel = new BroadcastChannel('selection-update-' + syncKey);
    loadedResultsSyncChannel = new BroadcastChannel('loaded-search-results-' + syncKey);

    imageViewerWindow = window.open(`/client/plants/${apiPlantUuid}/image-viewer/${syncKey}/${JSON.stringify(initialResultIds)}`);
    imageViewerLaunched = true;

    // Chrome 86 introduced a change that made the beforeunload event not register unless it was done after the page was loaded
    imageViewerWindow.addEventListener('load', () => {
        imageViewerWindow.addEventListener('beforeunload', () => {
            imageViewerLaunched = false;
            imageViewerWindow = null;
            setFlagIconAll('view-image', false);
            selectResult(-1);
        });
    })

    createBroadcastChannelListeners();
}


function addResultToImageViewer(resultId) {
    launchImageViewer([resultId]);

    loadedResultsSyncChannel.postMessage({
        resultIdsToAdd: [resultId],
        resultIdsToRemove: []
    });

    setFlagIcon(resultId, 'view-image', true);
    selectResult(resultId);
}

function addResultsToImageViewer(resultIds) {
    launchImageViewer(resultIds);

    loadedResultsSyncChannel.postMessage({
        resultIdsToAdd: resultIds,
        resultIdsToRemove: []
    });

    resultIds.forEach(function (resultId) {
        setFlagIcon(resultId, 'view-image', true);
    });

    if (resultIds.length > 0) {
        selectResult(resultIds[0]);
    }
}

function createBroadcastChannelListeners() {
    flagSyncChannel.onmessage = function (ev) {
        ev.data.forEach(function (patchRequest) {
            patchRequest.flags.forEach(function (flag) {
                console.log(flag);
                if (flag.flag === 'isExpanded') {
                    // this.isExpanded = flag.state === true;
                }
                if (flag.flag === 'isFlagged') {
                    setFlaggedFlagIcon(patchRequest.resultId, flag.state);
                }
                if (flag.flag === 'isInFinalChain') {
                    setInFinalChainFlagIcon(patchRequest.resultId, flag.state);
                    falloutDisplayAction(patchRequest.resultId);
                    reloadFinalChain();
                }
                if (flag.flag === 'isStruckOut') {
                    setStrikethroughFlagIcon(patchRequest.resultId, flag.state);
                    setStrikethroughLineState(patchRequest.resultId, flag.state);
                    falloutDisplayAction(patchRequest.resultId);
                }
            });
        });
    };

    selectionSyncChannel.onmessage = ev => {
        console.log('Selected: ' + ev.data.resultId);
        selectResult(ev.data.resultId, ev.data.scrollToResult);
    };

    loadedResultsSyncChannel.onmessage = ev => {
        const resultIdsToRemove = ev.data.resultIdsToRemove;
        resultIdsToRemove.forEach(function (resultId) {
            setFlagIcon(resultId, 'view-image', false);
        });
    };
}

function notifyFlagChange(resultId, flag, state) {
    notifyFlagChanges([{
        resultId: resultId, flags: [{flag: flag, state: state}]
    }])
}

function notifyFlagChangeMultiple(resultIds, flag, state) {
    let patchRequests = [];
    resultIds.forEach(function (resultId) {
        patchRequests.push({resultId: resultId, flags: [{flag: flag, state: state}]})
    });
    notifyFlagChanges(patchRequests);
}

function notifyFlagChanges(resultFlags) {
    if (imageViewerLaunched) {
        flagSyncChannel.postMessage(resultFlags);
    }
}

function selectResult(resultId, scrollToResult = false) {
    const selectedClass = 'selected-result';
    $('.' + selectedClass).each(function () {
        $(this).removeClass(selectedClass);
    });
    const matchingResultRows = $('.document-summary[data-result-id=' + resultId + ']');
    matchingResultRows.each(function () {
        $(this).addClass(selectedClass);
    });

    if (scrollToResult && matchingResultRows.length > 0) {
        const rowToScrollTo = matchingResultRows.not('fallout-history').not('fallout-history-hidden').first();
        const searchId = rowToScrollTo.data('searchId');
        switchTab(searchId);

        $(window).scrollTop(rowToScrollTo.offset().top - 100);

    }
}
